import { Link } from 'react-router-dom';
import { useState, useEffect } from "react";
import PortfolioGrid from './PortfolioGrid';

const Profile = () => {
    const [dateTime, setDateTime] = useState("");

    useEffect(() => {
        const updateTime = () => {
            const now = new Date();
            const options = { weekday: "long", month: "short", day: "2-digit" };
            const formattedDate = now.toLocaleDateString("en-US", options);
            const formattedTime = now.toLocaleTimeString("en-US", {
                hour: "2-digit",
                minute: "2-digit",
            });

            setDateTime(`${formattedDate} ${formattedTime}`);
        };

        updateTime();
        const interval = setInterval(updateTime, 60000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="mt-6">
            <div className="dark:text-[#525252] text-gray-400 px-8 sm:flex justify-between items-center">
                <div>
                    <span className="lg:ml-[13rem] md:ml-[6rem] sm:ml-[7rem] ml-[9rem] italic text-sm font-semibold text-[#424243] dark:text-white">/ma-boo-high!/</span>
                    <p className="lg:text-2xl md:text-lg text-md mb-5">
                        Hello there, ᜋᜊᜓᜑᜌ᜔!
                    </p>
                </div>

                <p className="lg:text-2xl md:text-lg text-md">{dateTime}</p>
            </div>
            {/* About */}
            <div className="px-[2rem] flex justify-center items-center">
                <div className="mt-4 flex flex-col items-left">
                    <p className="bg-gradient-to-r from-[#808183] to-[#3f3f40] dark:from-[#777777] dark:to-[#ffffff] bg-clip-text text-transparent text-2xl lg:text-4xl md:text-3xl font-semibold">
                        Kyle is a full-stack developer, designer, and artist who specializes in web development. He also has experience in game development and 3D modeling. A self-taught Blender enthusiast and verified Nexus Mod author, he enjoys learning new skills, and exploring new technologies.
                    </p>                    
                        <p className="text-gray-400 dark:text-[#525252] text-lg mt-[1rem]">Please note that this portfolio website is still a work in progress! Some links may not work yet, but you can view the featured projects below and my contact info.</p>
                </div>
            </div>
                <div className="w-full mt-[4rem] px-8">
                    <div className="h-[1px] bg-gray-300 dark:bg-[#525252] mx-auto">
                    </div>
                    <p className="text-gray-400 dark:text-[#525252] text-md mt-[1rem]">FEATURED WORK</p>
                </div>
                <PortfolioGrid/>
        </div>
    );
};

export default Profile;
